import React from 'react';
import useRouter from 'use-react-router';
import { useDispatch, useSelector } from 'react-redux';
import { Dispatch } from 'redux';
import { isEmpty } from 'lodash';
import modalActions from '@mm/state/modules/modalsState/actions';
import { StoreState } from '@mm/state/store-interfaces';
import { activeChatbotIdSelector } from '@mm/state/selectors/viewSelectors';
import { MessengerAdModel } from '@mm/state/model/MessengerAdModel';
import MessengerAdCRUDActions from '@mm/state/actions/MessengerAdCRUDActions';
import { DEFAULT_NAME, SYNC_ADS, SAVE_ADS } from '../../../constants/constants';
import { EditHeader } from '../../EditHeader/EditHeader';
import { BotBuilderRoutes } from '../../../../../../routes/bot-builder-routes';
import classNames from 'classnames';

type Props = {
  messengerAd: MessengerAdModel | null;
  onSaveName?: (name: string) => void;
  onSaveClick: () => void;
  showPublish: boolean;
  canPublish: boolean;
  errors?: string[];
  isTemplateBot: boolean;
  showOnlyActionButton?: boolean;
  actionButtonClassName?: string;
};

export const EditMessengerAdHeader = (props: Props) => {
  const {
    messengerAd,
    onSaveName,
    onSaveClick,
    canPublish,
    errors,
    isTemplateBot,
    showPublish,
    showOnlyActionButton,
    actionButtonClassName,
  } = props;
  const valid = isEmpty(errors);
  const dispatch: Dispatch<StoreState> = useDispatch();
  const chatbotId = useSelector(activeChatbotIdSelector);
  const { history } = useRouter();

  const onClickDelete = () => {
    if (!messengerAd) {
      return;
    }
    const deleteCallback = async () => {
      if (messengerAd !== null) {
        await dispatch(MessengerAdCRUDActions.delete(chatbotId, messengerAd));
      }

      const isLegacy = messengerAd.legacy;
      const redirectPath = BotBuilderRoutes.campaigns.getLink({
        chatbotId,
        kind: isLegacy ? 'legacy_messenger_ads' : 'ctm_ads',
      });

      history.push(redirectPath);
    };

    dispatch(
      modalActions.openDeleteConfirmModal({
        headerText: `Are you sure you want to delete this ${
          messengerAd.draft ? 'ad draft' : 'ad'
        }?`,
        deleteCallback,
      }),
    );
  };

  return (
    <EditHeader
      defaultName={DEFAULT_NAME}
      valid={valid}
      entity={messengerAd}
      errors={errors}
      saveButtonClass={classNames(
        'edit-header__save-button',
        actionButtonClassName,
      )}
      saveButtonText={!messengerAd || messengerAd.draft ? SYNC_ADS : SAVE_ADS}
      onClickDelete={onClickDelete}
      onSaveName={onSaveName}
      showSave={showPublish}
      onSaveClick={onSaveClick}
      saveDisabled={!messengerAd || !canPublish || isTemplateBot}
      showOnlyActionButton={showOnlyActionButton}
    />
  );
};
